export const PORTAL_IMAGE_CONTRACT_VERSION = "portal-image-v1";

export const PORTAL_IMAGE_VIEWPORTS = Object.freeze(["mobile", "tablet", "desktop"]);

export const PORTAL_IMAGE_PRESETS = Object.freeze({
  ENTITY: "entity",
  BANNER: "banner",
  PROMOTION: "promotion",
  PACKAGE: "package",
  WEBSITE_CONTENT: "website_content",
  DESTINATION_MEDIA: "destination_media",
  INVENTORY_MEDIA: "inventory_media",
  GALLERY_MEDIA: "gallery_media",
  GENERAL: "general",
});

export const PORTAL_IMAGE_SLOTS = Object.freeze({
  entity: Object.freeze({
    HERO_MOBILE: "entity_hero_mobile",
    HERO_TABLET: "entity_hero_tablet",
    HERO_DESKTOP: "entity_hero_desktop",
    HOME_CARD_MOBILE: "entity_home_card_mobile",
    HOME_CARD_DESKTOP: "entity_home_card_desktop",
    EXPLORE_MORE_MOBILE: "entity_explore_more_mobile",
    EXPLORE_MORE_DESKTOP: "entity_explore_more_desktop",
    RECENT_SEARCH_MOBILE: "entity_recent_search_mobile",
    RECENT_SEARCH_DESKTOP: "entity_recent_search_desktop",
    DESTINATION_CARD_MOBILE: "entity_destination_card_mobile",
    DESTINATION_CARD_DESKTOP: "entity_destination_card_desktop",
    STAY_CARD_MOBILE: "entity_stay_card_mobile",
    STAY_CARD_DESKTOP: "entity_stay_card_desktop",
    EXPERIENCE_CARD_MOBILE: "entity_experience_card_mobile",
    EXPERIENCE_CARD_DESKTOP: "entity_experience_card_desktop",
    EXPERIENCE_LISTING_MOBILE: "entity_experience_listing_mobile",
    EXPERIENCE_LISTING_DESKTOP: "entity_experience_listing_desktop",
    NEARBY_DESTINATION_MOBILE: "entity_nearby_destination_mobile",
    NEARBY_DESTINATION_DESKTOP: "entity_nearby_destination_desktop",
    ROOM_DETAIL_GALLERY_MOBILE: "entity_room_detail_gallery_mobile",
    ROOM_DETAIL_HERO_DESKTOP: "entity_room_detail_hero_desktop",
    ROOM_DETAIL_THUMB_DESKTOP: "entity_room_detail_thumb_desktop",
    SEARCH_THUMB_MOBILE: "entity_search_thumb_mobile",
    SEARCH_THUMB_DESKTOP: "entity_search_thumb_desktop",
    DESTINATION_MOSAIC_MOBILE: "entity_destination_mosaic_mobile",
    DESTINATION_MOSAIC_DESKTOP: "entity_destination_mosaic_desktop",
    DESTINATION_MOSAIC_4X3: "entity_destination_mosaic_4x3",
    DESTINATION_MOSAIC_SQUARE: "entity_destination_mosaic_square",
    EXPLORE_COMPACT_MOBILE: "entity_explore_compact_mobile",
    EXPLORE_COMPACT_DESKTOP: "entity_explore_compact_desktop",
    ON_GROUND_COVER_MOBILE: "entity_onground_cover_mobile",
    ON_GROUND_COVER_DESKTOP: "entity_onground_cover_desktop",
    MEDIUM_THUMB_DESKTOP: "entity_medium_thumb_desktop",
  }),
  banner: Object.freeze({
    HERO_MOBILE: "banner_hero_mobile",
    HERO_TABLET: "banner_hero_tablet",
    HERO_DESKTOP: "banner_hero_desktop",
    HERO_WIDE: "banner_hero_wide",
    SEARCH_THUMB: "banner_search_thumb",
    MEDIUM_THUMB: "banner_medium_thumb",
  }),
  promotion: Object.freeze({
    BANNER_MOBILE: "promotion_mobile_banner",
    BANNER_DESKTOP: "promotion_desktop_banner",
    INLINE_TABLET: "promotion_tablet_inline",
    INLINE_DESKTOP: "promotion_desktop_inline",
    MODAL_MOBILE: "promotion_mobile_modal",
    MODAL_TABLET: "promotion_tablet_modal",
    MODAL_DESKTOP: "promotion_desktop_modal",
    THUMB_MOBILE: "promotion_mobile_thumb",
    THUMB_DESKTOP: "promotion_desktop_thumb",
    SEARCH_THUMB: "promotion_search_thumb",
  }),
  package: Object.freeze({
    HERO_MOBILE: "package_hero_mobile",
    HERO_DESKTOP: "package_hero_desktop",
    HERO_WIDE: "package_hero_wide",
    CARD: "package_card",
    GALLERY: "package_gallery",
    GALLERY_4X3: "package_gallery_4x3",
    LIGHTBOX: "package_lightbox",
    THUMB: "package_thumb",
    SEARCH_THUMB: "package_search_thumb",
  }),
  website_content: Object.freeze({
    HERO_MOBILE: "content_hero_mobile",
    HERO_DESKTOP: "content_hero_desktop",
    CARD_MOBILE: "content_card_mobile",
    CARD_DESKTOP: "content_card_desktop",
    INLINE_640: "content_inline_640",
    INLINE_960: "content_inline_960",
    INLINE_1280: "content_inline_1280",
    THUMB: "content_thumb",
    SEARCH_THUMB: "content_search_thumb",
  }),
  gallery_media: Object.freeze({
    GRID_MAIN: "gallery_grid_main",
    GRID_SIDE: "gallery_grid_side",
    TILE_4X3: "gallery_tile_4x3",
    TILE_LANDSCAPE: "gallery_tile_landscape",
    STORY_MOBILE: "gallery_story_mobile",
    STORY_TABLET: "gallery_story_tablet",
    LIGHTBOX: "gallery_lightbox",
    THUMB: "gallery_thumb",
    SEARCH_THUMB: "gallery_search_thumb",
  }),
  general: Object.freeze({
    MOBILE_320: "general_mobile_320",
    MOBILE_640: "general_mobile_640",
    FLUID_640: "general_fluid_640",
    FLUID_960: "general_fluid_960",
    DESKTOP_1280: "general_desktop_1280",
    FLUID_1280: "general_fluid_1280",
    FLUID_1920: "general_fluid_1920",
    THUMB_150: "general_thumb_150",
    THUMB_300: "general_thumb_300",
    SEARCH_THUMB: "general_search_thumb",
  }),
});

const output = (role, variantKey, width, height) =>
  Object.freeze({ role, variantKey, format: "webp", width, height });

export const PORTAL_IMAGE_OUTPUTS = Object.freeze(
  Object.fromEntries(
    [
      [PORTAL_IMAGE_SLOTS.entity.HERO_MOBILE, "mobile", "hero_mobile_768x960", 768, 960],
      [PORTAL_IMAGE_SLOTS.entity.HERO_TABLET, "tablet", "hero_tablet_1280x900", 1280, 900],
      [PORTAL_IMAGE_SLOTS.entity.HERO_DESKTOP, "desktop", "hero_desktop_1920x980", 1920, 980],
      [PORTAL_IMAGE_SLOTS.entity.HOME_CARD_MOBILE, "mobile", "home_rail_card_4x5", 900, 1125],
      [PORTAL_IMAGE_SLOTS.entity.HOME_CARD_DESKTOP, "desktop", "home_rail_card_4x5", 900, 1125],
      [PORTAL_IMAGE_SLOTS.entity.EXPLORE_MORE_MOBILE, "mobile", "home_explore_more_grid_4x5", 900, 1125],
      [PORTAL_IMAGE_SLOTS.entity.EXPLORE_MORE_DESKTOP, "desktop", "home_explore_more_grid_4x5", 900, 1125],
      [PORTAL_IMAGE_SLOTS.entity.RECENT_SEARCH_MOBILE, "mobile", "recent_search_rail_mobile", 720, 916],
      [PORTAL_IMAGE_SLOTS.entity.RECENT_SEARCH_DESKTOP, "desktop", "recent_search_rail_desktop", 960, 916],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_MOBILE, "mobile", "popular_destination_mobile_720x860", 720, 860],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_DESKTOP, "desktop", "popular_destination_desktop_900x1200", 900, 1200],
      [PORTAL_IMAGE_SLOTS.entity.STAY_CARD_MOBILE, "mobile", "stay_accommodation_deck_mobile", 720, 1160],
      [PORTAL_IMAGE_SLOTS.entity.STAY_CARD_DESKTOP, "desktop", "stay_accommodation_deck_desktop", 900, 1200],
      [PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_MOBILE, "mobile", "experience_glow_card_mobile", 720, 1080],
      [PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_DESKTOP, "desktop", "experience_glow_card_desktop", 1000, 1050],
      [PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_LISTING_MOBILE, "mobile", "experience_listing_mobile_1000x640", 1000, 640],
      [PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_LISTING_DESKTOP, "desktop", "experience_listing_desktop_1000x1050", 1000, 1050],
      [PORTAL_IMAGE_SLOTS.entity.NEARBY_DESTINATION_MOBILE, "mobile", "nearby_destination_card_mobile", 1000, 620],
      [PORTAL_IMAGE_SLOTS.entity.NEARBY_DESTINATION_DESKTOP, "desktop", "nearby_destination_card_desktop", 900, 900],
      [PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_GALLERY_MOBILE, "mobile", "room_detail_gallery_16x9", 1280, 720],
      [PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_HERO_DESKTOP, "desktop", "room_detail_hero_1200x675", 1200, 675],
      [PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_THUMB_DESKTOP, "desktop", "room_detail_thumb_640x360", 640, 360],
      [PORTAL_IMAGE_SLOTS.entity.SEARCH_THUMB_MOBILE, "mobile", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.entity.SEARCH_THUMB_DESKTOP, "desktop", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_MOBILE, "mobile", "mosaic_9x16_900x1600", 900, 1600],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_DESKTOP, "desktop", "mosaic_16x9_1600x900", 1600, 900],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_4X3, "desktop", "mosaic_4x3_1200x900", 1200, 900],
      [PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_SQUARE, "desktop", "mosaic_square_1000x1000", 1000, 1000],
      [PORTAL_IMAGE_SLOTS.entity.EXPLORE_COMPACT_MOBILE, "mobile", "explore_card_1000x640", 1000, 640],
      [PORTAL_IMAGE_SLOTS.entity.EXPLORE_COMPACT_DESKTOP, "desktop", "explore_card_1000x640", 1000, 640],
      [PORTAL_IMAGE_SLOTS.entity.ON_GROUND_COVER_MOBILE, "mobile", "onground_cover_1000x720", 1000, 720],
      [PORTAL_IMAGE_SLOTS.entity.ON_GROUND_COVER_DESKTOP, "desktop", "onground_cover_1000x720", 1000, 720],
      [PORTAL_IMAGE_SLOTS.entity.MEDIUM_THUMB_DESKTOP, "desktop", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.banner.HERO_MOBILE, "mobile", "hero_mobile_768x960", 768, 960],
      [PORTAL_IMAGE_SLOTS.banner.HERO_TABLET, "tablet", "hero_tablet_1280x900", 1280, 900],
      [PORTAL_IMAGE_SLOTS.banner.HERO_DESKTOP, "desktop", "hero_desktop_1920x980", 1920, 980],
      [PORTAL_IMAGE_SLOTS.banner.HERO_WIDE, "desktop", "hero_wide_2560x1280", 2560, 1280],
      [PORTAL_IMAGE_SLOTS.banner.SEARCH_THUMB, "desktop", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.banner.MEDIUM_THUMB, "desktop", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.promotion.BANNER_MOBILE, "mobile", "promo_mobile_1080x1350", 1080, 1350],
      [PORTAL_IMAGE_SLOTS.promotion.BANNER_DESKTOP, "desktop", "promo_desktop_1600x720", 1600, 720],
      [PORTAL_IMAGE_SLOTS.promotion.INLINE_TABLET, "tablet", "promo_inline_1280x380", 1280, 380],
      [PORTAL_IMAGE_SLOTS.promotion.INLINE_DESKTOP, "desktop", "promo_inline_1280x380", 1280, 380],
      [PORTAL_IMAGE_SLOTS.promotion.MODAL_MOBILE, "mobile", "promo_modal_1200x1500", 1200, 1500],
      [PORTAL_IMAGE_SLOTS.promotion.MODAL_TABLET, "tablet", "promo_modal_1200x1500", 1200, 1500],
      [PORTAL_IMAGE_SLOTS.promotion.MODAL_DESKTOP, "desktop", "promo_modal_1200x1500", 1200, 1500],
      [PORTAL_IMAGE_SLOTS.promotion.THUMB_MOBILE, "mobile", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.promotion.THUMB_DESKTOP, "desktop", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.promotion.SEARCH_THUMB, "desktop", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.package.HERO_MOBILE, "default", "hero_mobile_768x960", 768, 960],
      [PORTAL_IMAGE_SLOTS.package.HERO_DESKTOP, "default", "hero_desktop_1920x980", 1920, 980],
      [PORTAL_IMAGE_SLOTS.package.HERO_WIDE, "default", "hero_wide_2560x1280", 2560, 1280],
      [PORTAL_IMAGE_SLOTS.package.CARD, "default", "package_card_900x1200", 900, 1200],
      [PORTAL_IMAGE_SLOTS.package.GALLERY, "default", "package_gallery_1200x900", 1200, 900],
      [PORTAL_IMAGE_SLOTS.package.GALLERY_4X3, "default", "gallery_4x3_1200x900", 1200, 900],
      [PORTAL_IMAGE_SLOTS.package.LIGHTBOX, "default", "gallery_lightbox_original", 1920, null],
      [PORTAL_IMAGE_SLOTS.package.THUMB, "default", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.package.SEARCH_THUMB, "default", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.website_content.HERO_MOBILE, "default", "hero_mobile_768x960", 768, 960],
      [PORTAL_IMAGE_SLOTS.website_content.HERO_DESKTOP, "default", "hero_desktop_1920x980", 1920, 980],
      [PORTAL_IMAGE_SLOTS.website_content.CARD_MOBILE, "default", "content_card_mobile_720x680", 720, 680],
      [PORTAL_IMAGE_SLOTS.website_content.CARD_DESKTOP, "default", "content_card_desktop_900x900", 900, 900],
      [PORTAL_IMAGE_SLOTS.website_content.INLINE_640, "default", "fluid_640", 640, null],
      [PORTAL_IMAGE_SLOTS.website_content.INLINE_960, "default", "fluid_960", 960, null],
      [PORTAL_IMAGE_SLOTS.website_content.INLINE_1280, "default", "fluid_1280", 1280, null],
      [PORTAL_IMAGE_SLOTS.website_content.THUMB, "default", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.website_content.SEARCH_THUMB, "default", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.gallery_media.GRID_MAIN, "default", "gallery_mosaic_main_1600x980", 1600, 980],
      [PORTAL_IMAGE_SLOTS.gallery_media.GRID_SIDE, "default", "gallery_mosaic_side_800x490", 800, 490],
      [PORTAL_IMAGE_SLOTS.gallery_media.TILE_4X3, "default", "gallery_4x3_1200x900", 1200, 900],
      [PORTAL_IMAGE_SLOTS.gallery_media.TILE_LANDSCAPE, "default", "gallery_mosaic_1200x800", 1200, 800],
      [PORTAL_IMAGE_SLOTS.gallery_media.STORY_MOBILE, "default", "gallery_story_mobile_1080", 1080, 1350],
      [PORTAL_IMAGE_SLOTS.gallery_media.STORY_TABLET, "default", "gallery_story_tablet_1440", 1440, 1024],
      [PORTAL_IMAGE_SLOTS.gallery_media.LIGHTBOX, "default", "gallery_lightbox_original", 1920, null],
      [PORTAL_IMAGE_SLOTS.gallery_media.THUMB, "default", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.gallery_media.SEARCH_THUMB, "default", "search_result_thumb_square", 160, 160],
      [PORTAL_IMAGE_SLOTS.general.MOBILE_320, "default", "mobile_320", 320, null],
      [PORTAL_IMAGE_SLOTS.general.MOBILE_640, "default", "mobile_640", 640, null],
      [PORTAL_IMAGE_SLOTS.general.FLUID_640, "default", "fluid_640", 640, null],
      [PORTAL_IMAGE_SLOTS.general.FLUID_960, "default", "fluid_960", 960, null],
      [PORTAL_IMAGE_SLOTS.general.DESKTOP_1280, "default", "desktop_1280", 1280, null],
      [PORTAL_IMAGE_SLOTS.general.FLUID_1280, "default", "fluid_1280", 1280, null],
      [PORTAL_IMAGE_SLOTS.general.FLUID_1920, "default", "fluid_1920", 1920, null],
      [PORTAL_IMAGE_SLOTS.general.THUMB_150, "default", "thumb_150", 150, 150],
      [PORTAL_IMAGE_SLOTS.general.THUMB_300, "default", "thumb_300", 300, 300],
      [PORTAL_IMAGE_SLOTS.general.SEARCH_THUMB, "default", "search_result_thumb_square", 160, 160],
    ].map(([slotKey, role, variantKey, width, height]) => [
      slotKey,
      output(role, variantKey, width, height),
    ]),
  ),
);

export const PORTAL_IMAGE_SIZE_POLICIES = Object.freeze({
  hero: Object.freeze({ maxBytes: 900 * 1024, maxWidth: 2560, label: "hero" }),
  card: Object.freeze({ maxBytes: 300 * 1024, maxWidth: 1200, label: "card" }),
  gallery: Object.freeze({ maxBytes: 650 * 1024, maxWidth: 1920, label: "gallery" }),
  thumbnail: Object.freeze({ maxBytes: 120 * 1024, maxWidth: 640, label: "thumbnail" }),
  mosaic: Object.freeze({ maxBytes: 700 * 1024, maxWidth: 1600, label: "mosaic" }),
  cover: Object.freeze({ maxBytes: 400 * 1024, maxWidth: 1200, label: "cover" }),
  lightbox: Object.freeze({ maxBytes: 1536 * 1024, maxWidth: 2560, label: "lightbox" }),
  banner: Object.freeze({ maxBytes: 900 * 1024, maxWidth: 1920, label: "banner" }),
  inline: Object.freeze({ maxBytes: 650 * 1024, maxWidth: 1280, label: "inline" }),
  modal: Object.freeze({ maxBytes: 700 * 1024, maxWidth: 1500, label: "modal" }),
  background: Object.freeze({ maxBytes: 1200 * 1024, maxWidth: 2560, label: "background" }),
});

const responsive = (mobile, tablet, desktop) =>
  Object.freeze({ mobile, tablet: tablet || desktop || mobile, desktop: desktop || tablet || mobile });

const ratios = (mobile, tablet, desktop) =>
  Object.freeze({ mobile, tablet: tablet || desktop || mobile, desktop: desktop || tablet || mobile });

const surface = ({
  presetKey,
  compatiblePresetKeys = [],
  kind,
  slots,
  aspectRatios,
  legacyFields,
  consumers,
  overrideFields = [],
  fit = "cover",
  priority = "standard",
  sizePolicy = null,
  preferDeliveryThumbnail = false,
  constrainLegacyToThumbnail = false,
}) =>
  Object.freeze({
    contractVersion: PORTAL_IMAGE_CONTRACT_VERSION,
    presetKey,
    compatiblePresetKeys: Object.freeze(compatiblePresetKeys),
    kind,
    slots,
    aspectRatios,
    legacyFields: Object.freeze(legacyFields),
    consumers: Object.freeze(consumers),
    overrideFields: Object.freeze(overrideFields),
    fit,
    priority,
    sizePolicy: sizePolicy || PORTAL_IMAGE_SIZE_POLICIES[kind] || PORTAL_IMAGE_SIZE_POLICIES.card,
    preferDeliveryThumbnail,
    constrainLegacyToThumbnail,
  });

const entityHeroFields = [
  "publicMedia.primary",
  "publicMedia.cover",
  "heroMedia.slots.hero",
  "heroImage",
  "coverImage",
  "gallery.0",
  "media.gallery.0",
];

const entityCardFields = [
  "publicMedia.cover",
  "publicMedia.primary",
  "publicGallery.cover",
  "canonicalImageDelivery.gallery.0",
  "coverImage",
  "destinationMedia.featured.main",
  "inventoryMedia.featured.main",
  "experienceMedia.featured.main",
  "heroMedia.slots.thumbnail",
  "thumbnailImage",
  "heroMedia.slots.hero",
  "heroImage",
  "gallery.0",
];

const compactEntityCardFields = [
  "heroMedia.slots.thumbnail",
  "thumbnailImage",
  ...entityCardFields,
];

const entityThumbFields = [
  "publicMedia.cover",
  "publicMedia.primary",
  "publicGallery.cover",
  "canonicalImageDelivery.gallery.0",
  "coverImage",
  "destinationMedia.featured.main",
  "inventoryMedia.featured.main",
  "experienceMedia.featured.main",
  "heroMedia.slots.thumbnail",
  "thumbnailImage",
  "heroMedia.slots.hero",
  "heroImage",
  "gallery.0",
];

const galleryThumbnailFields = [
  "thumbnailUrl",
  "thumbnailImage",
  "thumbnail",
  "thumb",
  "previewUrl",
  "preview",
];

const galleryFields = [...galleryThumbnailFields, "url", "lightboxUrl", "src", "image"];

export const PORTAL_IMAGE_SURFACES = Object.freeze({
  "homepage.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.BANNER,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.banner.HERO_MOBILE, PORTAL_IMAGE_SLOTS.banner.HERO_TABLET, PORTAL_IMAGE_SLOTS.banner.HERO_DESKTOP),
    aspectRatios: ratios("4 / 5", "64 / 45", "96 / 49"),
    legacyFields: ["media", "media.url", "heroImage", "entity.heroImage"],
    consumers: ["Components/Banner/Banner.jsx", "Pages/HomeLanding.jsx"],
    priority: "critical",
  }),
  "homepage.destination-rail": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HOME_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.HOME_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.HOME_CARD_DESKTOP),
    aspectRatios: ratios("4 / 5", "4 / 5", "4 / 5"),
    legacyFields: entityCardFields,
    consumers: ["Pages/HomeLanding.jsx"],
  }),
  "homepage.explore-more": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.EXPLORE_MORE_MOBILE, PORTAL_IMAGE_SLOTS.entity.EXPLORE_MORE_DESKTOP, PORTAL_IMAGE_SLOTS.entity.EXPLORE_MORE_DESKTOP),
    aspectRatios: ratios("4 / 5", "4 / 5", "4 / 5"),
    legacyFields: entityCardFields,
    consumers: ["Pages/HomeLanding.jsx", "Pages/Explore/ExploreHomeLanding.jsx"],
  }),
  "homepage.recent-search": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "thumbnail",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.MEDIUM_THUMB_DESKTOP, PORTAL_IMAGE_SLOTS.entity.MEDIUM_THUMB_DESKTOP, PORTAL_IMAGE_SLOTS.entity.MEDIUM_THUMB_DESKTOP),
    aspectRatios: ratios("1 / 1", "1 / 1", "1 / 1"),
    legacyFields: entityThumbFields,
    consumers: ["Pages/HomeLanding.jsx", "utils/recentlyVisited.js"],
  }),
  "homepage.popular-destination": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_DESKTOP),
    aspectRatios: ratios("36 / 43", "3 / 4", "3 / 4"),
    legacyFields: [
      ...entityCardFields,
      "media.thumbnailUrl",
      "media.thumbnail",
      "media.url",
      "media",
    ],
    consumers: ["Components/Destination/PopularDestinations.jsx"],
    priority: "critical",
    constrainLegacyToThumbnail: true,
  }),
  "homepage.experience-card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_DESKTOP),
    aspectRatios: ratios("5 / 6", "10 / 11", "10 / 11"),
    legacyFields: entityCardFields,
    consumers: ["Pages/HomeLanding.jsx"],
  }),
  "homepage.package-card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.CARD, PORTAL_IMAGE_SLOTS.package.CARD, PORTAL_IMAGE_SLOTS.package.CARD),
    aspectRatios: ratios("3 / 4", "3 / 4", "3 / 4"),
    legacyFields: ["heroMedia", "heroMedia.url", "heroImage", "coverImage", "gallery.0"],
    consumers: ["Pages/HomeLanding.jsx", "Pages/Packages/PackageListingPage.jsx"],
  }),
  "search.entity-result": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "thumbnail",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.SEARCH_THUMB_MOBILE, PORTAL_IMAGE_SLOTS.entity.SEARCH_THUMB_DESKTOP, PORTAL_IMAGE_SLOTS.entity.SEARCH_THUMB_DESKTOP),
    aspectRatios: ratios("1 / 1", "1 / 1", "1 / 1"),
    legacyFields: entityThumbFields,
    consumers: ["Components/Booking/LocationSearchCombobox.jsx", "Components/Booking/MobileWhereSheet.jsx"],
  }),
  "destination.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HERO_MOBILE, PORTAL_IMAGE_SLOTS.entity.HERO_TABLET, PORTAL_IMAGE_SLOTS.entity.HERO_DESKTOP),
    aspectRatios: ratios("4 / 5", "64 / 45", "96 / 49"),
    legacyFields: entityHeroFields,
    consumers: ["Pages/Explore/ExploreDestination.jsx", "Pages/Explore/ExploreDestinationDeepDive.jsx"],
    priority: "critical",
  }),
  "destination.card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.DESTINATION_CARD_DESKTOP),
    aspectRatios: ratios("36 / 43", "3 / 4", "3 / 4"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreCards.jsx", "Pages/Explore/ExploreDistrict.jsx"],
  }),
  "destination.mosaic-main": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "mosaic",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_MOBILE, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_DESKTOP, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_DESKTOP),
    aspectRatios: ratios("9 / 16", "16 / 9", "16 / 9"),
    legacyFields: entityHeroFields,
    consumers: ["Components/Banner/DestinationMosaicBanner.jsx", "Pages/Explore/IntroMosaicHeroBanner.jsx"],
    priority: "critical",
  }),
  "destination.mosaic-side": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "mosaic",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_4X3, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_4X3, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_4X3),
    aspectRatios: ratios("4 / 3", "4 / 3", "4 / 3"),
    legacyFields: [...galleryThumbnailFields, "url", ...entityCardFields],
    consumers: ["Components/Banner/DestinationMosaicBanner.jsx", "Pages/Explore/IntroMosaicHeroBanner.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: true,
  }),
  "destination.mosaic-square": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "mosaic",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_SQUARE, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_SQUARE, PORTAL_IMAGE_SLOTS.entity.DESTINATION_MOSAIC_SQUARE),
    aspectRatios: ratios("1 / 1", "1 / 1", "1 / 1"),
    legacyFields: [...galleryThumbnailFields, "url", ...entityThumbFields],
    consumers: ["Components/Banner/DestinationMosaicBanner.jsx", "Pages/Explore/IntroMosaicHeroBanner.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: true,
  }),
  "destination.nearby-card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.NEARBY_DESTINATION_MOBILE, PORTAL_IMAGE_SLOTS.entity.NEARBY_DESTINATION_DESKTOP, PORTAL_IMAGE_SLOTS.entity.NEARBY_DESTINATION_DESKTOP),
    aspectRatios: ratios("50 / 31", "1 / 1", "1 / 1"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreDestination.jsx", "Pages/Explore/ExploreCards.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: false,
  }),
  "destination.explore-compact": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.EXPLORE_COMPACT_MOBILE, PORTAL_IMAGE_SLOTS.entity.EXPLORE_COMPACT_DESKTOP, PORTAL_IMAGE_SLOTS.entity.EXPLORE_COMPACT_DESKTOP),
    aspectRatios: ratios("25 / 16", "25 / 16", "25 / 16"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreAtGlanceCard.jsx", "Pages/Explore/ExploreCards.jsx"],
  }),
  "destination.activity-cover": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "cover",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.ON_GROUND_COVER_MOBILE, PORTAL_IMAGE_SLOTS.entity.ON_GROUND_COVER_DESKTOP, PORTAL_IMAGE_SLOTS.entity.ON_GROUND_COVER_DESKTOP),
    aspectRatios: ratios("25 / 18", "25 / 18", "25 / 18"),
    legacyFields: ["coverImage", "image", "media.0", ...entityCardFields],
    consumers: ["Pages/Explore/OnGroundExperienceCard.jsx"],
  }),
  "camp.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HERO_MOBILE, PORTAL_IMAGE_SLOTS.entity.HERO_TABLET, PORTAL_IMAGE_SLOTS.entity.HERO_DESKTOP),
    aspectRatios: ratios("4 / 5", "64 / 45", "96 / 49"),
    legacyFields: entityHeroFields,
    consumers: ["Pages/Explore/ExploreCamp.jsx"],
    priority: "critical",
  }),
  "camp.card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.STAY_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.STAY_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.STAY_CARD_DESKTOP),
    aspectRatios: ratios("4 / 5", "3 / 4", "3 / 4"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreCards.jsx", "Pages/Explore/ExploreLanding.jsx"],
  }),
  "stay.accommodation-card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.STAY_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.STAY_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.STAY_CARD_DESKTOP),
    aspectRatios: ratios("4 / 5", "3 / 4", "3 / 4"),
    legacyFields: compactEntityCardFields,
    consumers: ["Pages/Explore/StayCards/StayAccommodationCard.jsx", "Pages/Explore/StayCards/StayAccommodationDeck.jsx", "Pages/Explore/Camp/CampStaySection.jsx"],
    constrainLegacyToThumbnail: true,
  }),
  "room.detail-hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_GALLERY_MOBILE, PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_HERO_DESKTOP, PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_HERO_DESKTOP),
    aspectRatios: ratios("16 / 9", "16 / 9", "16 / 9"),
    legacyFields: entityHeroFields,
    consumers: ["Pages/Explore/StayCards/StayDetailsModal.jsx", "Pages/Explore/StayCards/StayGalleryModal.jsx"],
  }),
  "room.detail-thumbnail": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "thumbnail",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_GALLERY_MOBILE, PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_THUMB_DESKTOP, PORTAL_IMAGE_SLOTS.entity.ROOM_DETAIL_THUMB_DESKTOP),
    aspectRatios: ratios("16 / 9", "16 / 9", "16 / 9"),
    legacyFields: [...galleryThumbnailFields, ...entityThumbFields],
    consumers: ["Pages/Explore/StayCards/StayDetailsModal.jsx"],
    sizePolicy: PORTAL_IMAGE_SIZE_POLICIES.gallery,
    constrainLegacyToThumbnail: true,
  }),
  "experience.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HERO_MOBILE, PORTAL_IMAGE_SLOTS.entity.HERO_TABLET, PORTAL_IMAGE_SLOTS.entity.HERO_DESKTOP),
    aspectRatios: ratios("4 / 5", "64 / 45", "96 / 49"),
    legacyFields: entityHeroFields,
    consumers: ["Pages/Explore/ExploreCruiseBoating.jsx", "Pages/Explore/ExploreJungleSafari.jsx", "Pages/Explore/ExploreTrekTrail.jsx"],
    priority: "critical",
  }),
  "experience.card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_CARD_DESKTOP),
    aspectRatios: ratios("5 / 6", "10 / 11", "10 / 11"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreCards.jsx", "Pages/Explore/ExploreExperienceLanding.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: true,
  }),
  "experience.listing": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_LISTING_MOBILE, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_LISTING_DESKTOP, PORTAL_IMAGE_SLOTS.entity.EXPERIENCE_LISTING_DESKTOP),
    aspectRatios: ratios("25 / 16", "20 / 21", "20 / 21"),
    legacyFields: entityCardFields,
    consumers: ["Pages/Explore/ExploreCruiseBoatingLanding.jsx", "Pages/Explore/ExploreTrekTrailLanding.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: true,
  }),
  "gallery.grid-main": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.GRID_MAIN, PORTAL_IMAGE_SLOTS.gallery_media.GRID_MAIN, PORTAL_IMAGE_SLOTS.gallery_media.GRID_MAIN),
    aspectRatios: ratios("80 / 49", "80 / 49", "80 / 49"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/MediaGallery.jsx", "Pages/Explore/MediaGalleryV2.jsx", "Pages/Explore/AminatedMediaGallary.jsx"],
  }),
  "gallery.grid-side": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.GRID_SIDE, PORTAL_IMAGE_SLOTS.gallery_media.GRID_SIDE, PORTAL_IMAGE_SLOTS.gallery_media.GRID_SIDE),
    aspectRatios: ratios("80 / 49", "80 / 49", "80 / 49"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/MediaGallery.jsx", "Pages/Explore/MediaGalleryV2.jsx", "Pages/Explore/AminatedMediaGallary.jsx"],
    constrainLegacyToThumbnail: true,
  }),
  "destination-media.grid-main": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    compatiblePresetKeys: [PORTAL_IMAGE_PRESETS.DESTINATION_MEDIA, PORTAL_IMAGE_PRESETS.INVENTORY_MEDIA],
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.STORY_MOBILE, PORTAL_IMAGE_SLOTS.gallery_media.STORY_TABLET, PORTAL_IMAGE_SLOTS.gallery_media.GRID_MAIN),
    aspectRatios: ratios("4 / 5", "45 / 32", "80 / 49"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/DestinationMediaGallery.jsx"],
  }),
  "destination-media.grid-side": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    compatiblePresetKeys: [PORTAL_IMAGE_PRESETS.DESTINATION_MEDIA, PORTAL_IMAGE_PRESETS.INVENTORY_MEDIA],
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.STORY_MOBILE, PORTAL_IMAGE_SLOTS.gallery_media.STORY_TABLET, PORTAL_IMAGE_SLOTS.gallery_media.GRID_SIDE),
    aspectRatios: ratios("4 / 5", "45 / 32", "80 / 49"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/DestinationMediaGallery.jsx"],
    constrainLegacyToThumbnail: true,
  }),
  "gallery.tile": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.TILE_4X3, PORTAL_IMAGE_SLOTS.gallery_media.TILE_4X3, PORTAL_IMAGE_SLOTS.gallery_media.TILE_4X3),
    aspectRatios: ratios("4 / 3", "4 / 3", "4 / 3"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/Camp/MediaGallery.jsx", "Pages/Explore/VerticalGallery.jsx"],
    constrainLegacyToThumbnail: true,
  }),
  "gallery.landscape": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.TILE_LANDSCAPE, PORTAL_IMAGE_SLOTS.gallery_media.TILE_LANDSCAPE, PORTAL_IMAGE_SLOTS.gallery_media.TILE_LANDSCAPE),
    aspectRatios: ratios("3 / 2", "3 / 2", "3 / 2"),
    legacyFields: galleryFields,
    consumers: ["Pages/Explore/MediaGallery.jsx", "Pages/Explore/MediaGalleryV2.jsx"],
    constrainLegacyToThumbnail: true,
  }),
  "gallery.lightbox": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    compatiblePresetKeys: [PORTAL_IMAGE_PRESETS.DESTINATION_MEDIA, PORTAL_IMAGE_PRESETS.INVENTORY_MEDIA],
    kind: "lightbox",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.STORY_MOBILE, PORTAL_IMAGE_SLOTS.gallery_media.STORY_TABLET, PORTAL_IMAGE_SLOTS.gallery_media.LIGHTBOX),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["lightboxUrl", "url", "src", "image"],
    consumers: ["Pages/Explore/ExploreImageLightbox.jsx", "Components/Gallery/Modal.jsx"],
    fit: "contain",
  }),
  "story.gallery": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    compatiblePresetKeys: [PORTAL_IMAGE_PRESETS.DESTINATION_MEDIA, PORTAL_IMAGE_PRESETS.INVENTORY_MEDIA],
    kind: "lightbox",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.STORY_MOBILE, PORTAL_IMAGE_SLOTS.gallery_media.STORY_TABLET, PORTAL_IMAGE_SLOTS.gallery_media.LIGHTBOX),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["lightboxUrl", "url", "src", "image"],
    consumers: ["Components/Story/MediaStoryViewer.jsx"],
    fit: "contain",
  }),
  "story.entity": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "lightbox",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HERO_MOBILE, PORTAL_IMAGE_SLOTS.entity.HERO_TABLET, PORTAL_IMAGE_SLOTS.entity.HERO_DESKTOP),
    aspectRatios: ratios(null, null, null),
    legacyFields: entityHeroFields,
    consumers: ["Components/Story/MediaStoryViewer.jsx"],
    fit: "contain",
  }),
  "story.package": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "lightbox",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.LIGHTBOX, PORTAL_IMAGE_SLOTS.package.LIGHTBOX, PORTAL_IMAGE_SLOTS.package.LIGHTBOX),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["lightboxUrl", "url", "src", "image", "heroImage", "gallery.0"],
    consumers: ["Components/Story/MediaStoryViewer.jsx"],
    fit: "contain",
  }),
  "gallery.thumbnail": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GALLERY_MEDIA,
    kind: "thumbnail",
    slots: responsive(PORTAL_IMAGE_SLOTS.gallery_media.THUMB, PORTAL_IMAGE_SLOTS.gallery_media.THUMB, PORTAL_IMAGE_SLOTS.gallery_media.THUMB),
    aspectRatios: ratios("1 / 1", "1 / 1", "1 / 1"),
    legacyFields: ["thumbnail", "thumbnailUrl", "url", "src"],
    consumers: ["Pages/Explore/MediaGallery.jsx", "Pages/Explore/MediaGalleryV2.jsx", "Pages/Explore/VerticalGallery.jsx"],
    preferDeliveryThumbnail: true,
    constrainLegacyToThumbnail: true,
  }),
  "package.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.HERO_MOBILE, PORTAL_IMAGE_SLOTS.package.HERO_DESKTOP, PORTAL_IMAGE_SLOTS.package.HERO_WIDE),
    aspectRatios: ratios("4 / 5", "96 / 49", "2 / 1"),
    legacyFields: ["heroMedia", "heroMedia.url", "heroImage", "coverImage", "gallery.0"],
    consumers: ["Components/Packages/ParallaxHero.jsx", "Pages/Packages/PackageListingPage.jsx"],
    priority: "critical",
  }),
  "package.card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.CARD, PORTAL_IMAGE_SLOTS.package.CARD, PORTAL_IMAGE_SLOTS.package.CARD),
    aspectRatios: ratios("3 / 4", "3 / 4", "3 / 4"),
    legacyFields: ["heroMedia", "heroMedia.url", "heroImage", "coverImage", "image", "gallery.0"],
    consumers: ["Pages/Packages/PackageListingPage.jsx", "Pages/Packages/PackageBookingDrawer.jsx", "Pages/Packages/PackageChangeDrawer.jsx"],
  }),
  "package.gallery": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "gallery",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.GALLERY_4X3, PORTAL_IMAGE_SLOTS.package.GALLERY_4X3, PORTAL_IMAGE_SLOTS.package.GALLERY_4X3),
    aspectRatios: ratios("4 / 3", "4 / 3", "4 / 3"),
    legacyFields: galleryFields,
    consumers: ["Pages/Packages/PackageMediaGallery.jsx", "Pages/Packages/PackageDetailPage.jsx"],
  }),
  "package.lightbox": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PACKAGE,
    kind: "lightbox",
    slots: responsive(PORTAL_IMAGE_SLOTS.package.LIGHTBOX, PORTAL_IMAGE_SLOTS.package.LIGHTBOX, PORTAL_IMAGE_SLOTS.package.LIGHTBOX),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["lightboxUrl", "url", "src", "image"],
    consumers: ["Components/Story/MediaStoryViewer.jsx", "Pages/Packages/PackageMediaGallery.jsx"],
    fit: "contain",
  }),
  "website-content.hero": surface({
    presetKey: PORTAL_IMAGE_PRESETS.WEBSITE_CONTENT,
    kind: "hero",
    slots: responsive(PORTAL_IMAGE_SLOTS.website_content.HERO_MOBILE, PORTAL_IMAGE_SLOTS.website_content.HERO_DESKTOP, PORTAL_IMAGE_SLOTS.website_content.HERO_DESKTOP),
    aspectRatios: ratios("4 / 5", "96 / 49", "96 / 49"),
    legacyFields: ["heroMedia", "heroMedia.url", "heroImage", "image", "url"],
    consumers: ["Pages/WebsiteContent/WebsiteContentRoute.jsx"],
    priority: "critical",
  }),
  "website-content.card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.WEBSITE_CONTENT,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.website_content.CARD_MOBILE, PORTAL_IMAGE_SLOTS.website_content.CARD_DESKTOP, PORTAL_IMAGE_SLOTS.website_content.CARD_DESKTOP),
    aspectRatios: ratios("18 / 17", "1 / 1", "1 / 1"),
    legacyFields: ["thumbnailMedia", "thumbnailMedia.url", "heroMedia", "heroMedia.url", "image", "url"],
    consumers: ["Pages/WebsiteContent/WebsiteContentRoute.jsx"],
  }),
  "website-content.inline": surface({
    presetKey: PORTAL_IMAGE_PRESETS.WEBSITE_CONTENT,
    kind: "inline",
    slots: responsive(PORTAL_IMAGE_SLOTS.website_content.INLINE_640, PORTAL_IMAGE_SLOTS.website_content.INLINE_960, PORTAL_IMAGE_SLOTS.website_content.INLINE_1280),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["url", "src", "image"],
    consumers: ["Pages/WebsiteContent/WebsiteContentRoute.jsx"],
    fit: "contain",
  }),
  "promotion.page-banner": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PROMOTION,
    kind: "banner",
    slots: responsive(PORTAL_IMAGE_SLOTS.promotion.BANNER_MOBILE, PORTAL_IMAGE_SLOTS.promotion.BANNER_DESKTOP, PORTAL_IMAGE_SLOTS.promotion.BANNER_DESKTOP),
    aspectRatios: ratios("4 / 5", "20 / 9", "20 / 9"),
    legacyFields: ["mediaSuite.slots.mobileBanner", "mediaSuite.slots.desktopBanner", "media", "media.url"],
    consumers: ["Components/Promotions/WebsitePromotionPageBanner.jsx"],
    priority: "critical",
  }),
  "promotion.inline": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PROMOTION,
    kind: "banner",
    slots: responsive(PORTAL_IMAGE_SLOTS.promotion.INLINE_TABLET, PORTAL_IMAGE_SLOTS.promotion.INLINE_TABLET, PORTAL_IMAGE_SLOTS.promotion.INLINE_DESKTOP),
    aspectRatios: ratios("64 / 19", "64 / 19", "64 / 19"),
    legacyFields: ["mediaSuite.slots.inlineBanner", "media", "media.url"],
    consumers: ["Pages/WebsiteContent/WebsiteContentRoute.jsx"],
  }),
  "promotion.modal": surface({
    presetKey: PORTAL_IMAGE_PRESETS.PROMOTION,
    kind: "modal",
    slots: responsive(PORTAL_IMAGE_SLOTS.promotion.MODAL_MOBILE, PORTAL_IMAGE_SLOTS.promotion.MODAL_TABLET, PORTAL_IMAGE_SLOTS.promotion.MODAL_DESKTOP),
    aspectRatios: ratios("4 / 5", "4 / 5", "4 / 5"),
    legacyFields: ["mediaSuite.slots.modalVisual", "media", "media.url"],
    consumers: ["Components/Promotions/WebsitePromotionModal.jsx"],
  }),
  "account.entity-card": surface({
    presetKey: PORTAL_IMAGE_PRESETS.ENTITY,
    kind: "card",
    slots: responsive(PORTAL_IMAGE_SLOTS.entity.HOME_CARD_MOBILE, PORTAL_IMAGE_SLOTS.entity.HOME_CARD_DESKTOP, PORTAL_IMAGE_SLOTS.entity.HOME_CARD_DESKTOP),
    aspectRatios: ratios("4 / 5", "4 / 5", "4 / 5"),
    legacyFields: ["destinationImage", "image", ...entityCardFields],
    consumers: ["Components/Account/BookingCard.jsx", "Pages/Account/AccountWishlist.jsx", "Pages/Account/components/ReceiptHeader.jsx"],
  }),
  "general.page-background": surface({
    presetKey: PORTAL_IMAGE_PRESETS.GENERAL,
    kind: "background",
    slots: responsive(PORTAL_IMAGE_SLOTS.general.MOBILE_640, PORTAL_IMAGE_SLOTS.general.FLUID_1280, PORTAL_IMAGE_SLOTS.general.FLUID_1920),
    aspectRatios: ratios(null, null, null),
    legacyFields: ["backgroundImage", "image", "url"],
    consumers: ["Components/Layout/InSitePageShell.jsx", "Pages/Packages/PackageListingPage.jsx"],
  }),
});

export const PORTAL_IMAGE_EXCLUSIONS = Object.freeze([
  Object.freeze({ key: "brand-assets", reason: "Static logos and contact icons remain bundled portal assets." }),
  Object.freeze({ key: "booking-qr", reason: "Generated QR codes are transactional data, not managed media." }),
  Object.freeze({ key: "route-maps", reason: "Generated map previews retain their map-specific delivery flow." }),
  Object.freeze({ key: "review-media", reason: "Customer review uploads require a separate moderation and optimization policy." }),
  Object.freeze({ key: "demo-decoration", reason: "Demo and decorative shape assets are outside the managed content contract." }),
]);

export const PORTAL_IMAGE_SURFACE_KEYS = Object.freeze(Object.keys(PORTAL_IMAGE_SURFACES));

export const getPortalImageSurface = (surfaceKey) => PORTAL_IMAGE_SURFACES[surfaceKey] || null;

export const getPortalImageSizePolicy = (surfaceKey) => (
  getPortalImageSurface(surfaceKey)?.sizePolicy || null
);

export const getPortalImageSlot = (surfaceKey, viewport = "desktop") => {
  const surfaceDefinition = getPortalImageSurface(surfaceKey);
  if (!surfaceDefinition) return "";
  const normalizedViewport = PORTAL_IMAGE_VIEWPORTS.includes(viewport) ? viewport : "desktop";
  return surfaceDefinition.slots[normalizedViewport] || surfaceDefinition.slots.desktop || "";
};

export const getPortalImageAspectRatio = (surfaceKey, viewport = "desktop") => {
  const surfaceDefinition = getPortalImageSurface(surfaceKey);
  if (!surfaceDefinition) return null;
  const normalizedViewport = PORTAL_IMAGE_VIEWPORTS.includes(viewport) ? viewport : "desktop";
  return surfaceDefinition.aspectRatios[normalizedViewport] ?? surfaceDefinition.aspectRatios.desktop ?? null;
};

export default PORTAL_IMAGE_SURFACES;
